import { InteractionRequiredAuthError } from '@azure/msal-browser'

import type { Logger } from '@/lib/logger'

import { msalInstance } from './instance'

const requestOptions = {
  scopes: [`${import.meta.env.VITE_B2C_APP_ID}`],
}

export type GetAccessToken = (logger: Logger) => Promise<string>

export const getAccessToken: GetAccessToken = async logger => {
  try {
    const tokenResponse = await msalInstance.acquireTokenSilent({
      ...requestOptions,
      account: msalInstance.getAllAccounts()[0] ?? undefined,
    })

    return tokenResponse.accessToken
  } catch (e) {
    if (e instanceof InteractionRequiredAuthError) {
      redirectToLogin(logger)

      return Promise.reject(e)
    }

    logger.error('Error getting access token', { error: e })

    return Promise.reject(e)
  }
}

export const redirectToLogin = (logger: Logger): void => {
  logger.info('Redirect to login')

  try {
    msalInstance.loginRedirect(requestOptions)
  } catch (e) {
    logger.error('Error getting access token - failed interaction', { error: e })
  }
}
